export { StoreIcon } from './store'
